import React from 'react'
import { CategoryLandingPageNavigationItemType } from '.'
import CategoryThumbnail from '@dustin-web/product-components/src/category-thumbnail'
import { getCategoryUrl, getRelativeProductImageUrl } from '@dustin-web/microsite-components/src/utils/urls'

type Props = {
  items: CategoryLandingPageNavigationItemType[]
  itemOnClick?: (selection: string) => void
}

export const CategoriesThumbnail = ({ items, itemOnClick }: Props) => {
  if (!items.length) {
    return null
  }

  return (
    <div className="row">
      {items.map(
        ({ category, categoryId }) =>
          !!category && (
            <div className="col-6 col-lg-3" key={categoryId}>
              <CategoryThumbnail
                imgSrc={getRelativeProductImageUrl(
                  category.categoryImages?.[0]?.imageFileName,
                  54,
                  41
                )}
                href={getCategoryUrl(category?.pathSlug)}
                name={category.name || undefined}
                itemOnClick={itemOnClick}
                englishCategoryName={category?.englishCategoryName}
              />
            </div>
          )
      )}
    </div>
  )
}
export default CategoriesThumbnail
